// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Timeline
     */

    function setActiveTimeline() {
        const timelineTriggers = document.querySelectorAll('.js-timeline');
        const timelineDots = document.querySelectorAll('.timeline__dot');
        const timelineDotsContainer = document.querySelector('.timeline__dots');
        let timelineActiveTrigger = null;
        let timelineActiveTriggerId = null;
        const timelineTriggerPoint = window.innerHeight * 0.33; // 33% de la hauteur de l'écran

        timelineTriggers.forEach(timelineTrigger => {
            const timelineTriggersContainer = timelineTrigger.getBoundingClientRect();
            if (timelineTriggersContainer.top <= timelineTriggerPoint && timelineTriggersContainer.bottom >= timelineTriggerPoint) {
                timelineActiveTrigger = timelineTrigger;
                timelineActiveTriggerId = timelineTrigger.dataset.timeline;
            }
        });
    
        timelineTriggers.forEach(timelineTrigger => {
            if (timelineTrigger === timelineActiveTrigger) {
                timelineTrigger.classList.add('timeline__item--active');
            } else {
                timelineTrigger.classList.remove('timeline__item--active');
            }
        });
    
        timelineDots.forEach(timelineDot => {
            if (timelineDot.dataset.timeline === timelineActiveTriggerId) {
                timelineDot.classList.add('timeline__dot--active');
            } else {
                timelineDot.classList.remove('timeline__dot--active');
            }
        });

        if (timelineDotsContainer && timelineActiveTriggerId != null) {
            timelineDotsContainer.classList.add('timeline__dots--active');
        } else {
            timelineDotsContainer.classList.remove('timeline__dots--active');
        }
    }
    
    if (document.querySelector('.js-timeline')) {
        document.addEventListener('scroll', setActiveTimeline);
        setActiveTimeline();
    }

});
